module.exports = __webpack_public_path__ + "static/media/kia-phone.e66472ca.svg";